import type { FC } from 'react';
import ClaimsSettingsScreen from '../../screens/Claims/Settings/claims-settings-screen';

const ClaimsSettingsPage: FC = () => {
  return <ClaimsSettingsScreen />;
};

export default ClaimsSettingsPage;
